export const GTM_ID = 'GTM-KNLRVSG';
export const COOKIEBOT_ID = '6bd2ef99-181a-4501-8e0c-2a21c9d1c788';

export const ELOQUA_VIRTUAL_PATH = '/external/eloqua';
export const ELOQUA_BASE_URL = 'https://secure.p01.eloqua.com/API/REST';
export const ELOQUA_BASIC_AUTH = 'Basic U1BTXENNUy5JbnRlZ3JhdGlvbjpDTVNASW50ZWdyYXRpb24xMjM=';
export const ELOQUA_HTTP_TIMEOUT = 10000;
export const ELOQUA_CACHE_TIME = 60 * 60 * 1000; // 1 hour
export const ELOQUA_EXPIRY_TIME = 90 * 24 * 60 * 60 * 1000; // 90 days;

export const SENTRY = {
  TOKEN:
    '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',
  DSN: 'https://d79d445b854f414c4ff5110880e3a1df@o4506823629602816.ingest.sentry.io/4506823633993728',
  DENIED_URLS: [/sleeknote\.com/, /clarity\.ms/, /ldgnrtn\.com/, /translate-pa.googleapis\.com/],
  IGNORE_ERRORS: ['telephone', /ASSERTION ERROR/i],
};

export const ELOQUA_LANGUAGES: { [isoAlpha2: string]: string } = {
  en: 'ENGLISH',
  fr: 'FRENCH',
  de: 'GERMAN',
  it: 'ITALIAN',
  es: 'SPANISH',
  sk: 'SLOVAK',
};

export const ELOQUA_EMAIL_PROVIDER_BLACKLIST = ['hotmail', 'gmail', 'yahoo', 'msn', 'aol', 'icloud', 'protonmail'];

export const CUSTOM_GPT = {
  scriptId: 'custom-gpt-script',
  scriptSrc: 'https://cdn.customgpt.ai/js/embed.js',
  id: '10739',
  key: 'b612d28fd24494eafb5c8e431f689ca0',
  divId: 'custom-gpt',
  iframeHeight: '750px',
  enabledPages: ['/en/sales-team','/en/test-pages/test-page','/en/investors'],
};
